import { DOCUMENTS_HUB_ENABLED, HR_HUB_ENABLED } from '@/config/featureFlags';

const knownHomeSections = new Set([
  'business',
  'business/dashboard',
  'unified-dashboard',
  'business/personale',
  'personale',
  'business/portafoglio',
  'wallet',
  'business/fornitori',
  'hr',
  'hr/soci-e-dipendenti',
  'hr/cedolini',
  'hr/carica-dati',
  'hr/inail',
  'hr/parametri',
  'hr/turni',
  'dipendenze',
  'dipendenze/dashboard',
  'piani-terapeutici',
  'piani-terapeutici/carica-dati',
  'piani-terapeutici/questionari',
  'piani-terapeutici/assistiti',
  'piani-terapeutici/piani',
  'piani-terapeutici/assistente-ia',
  'area-sanitaria',
  'gestione-terapia',
  'gestione-ordini',
  'gestione-stdp',
  'gestione-mmg',
  'contatti-utili',
  'dipendenze/gestione-assistiti',
  'dipendenze/gestione-strutture',
  'applicativi',
  'admin',
  'admin/access-control',
  'admin/caricamenti',
  'admin/caricamento-dati',
  'admin/data-imports',
  'admin/caricamento-gisss',
  'admin/caricamento-fornitori',
  'admin/utenti',
  'admin/notifiche',
  'admin/sicurezza',
  'admin/manutenzione',
]);

export function isKnownHomeSection(currentSection: string): boolean {
  if (!DOCUMENTS_HUB_ENABLED && (
    currentSection === 'documents'
    || currentSection === 'documenti'
    || currentSection.startsWith('documents/')
    || currentSection.startsWith('documenti/')
  )) {
    return false;
  }
  if (!HR_HUB_ENABLED && currentSection.startsWith('hr')) return false;

  if (isLegacyDocumentSection(currentSection)) return true;
  if ([
    'documents',
    'documents/catalog',
    'documents/acquisition',
    'documents/manage',
    'documents/links',
    'documents/configuration',
    'documents/configuration/taxonomies',
    'documents/configuration/document-types',
  ].includes(currentSection)) return true;

  return /^documents\/[0-9a-f-]{36}$/i.test(currentSection)
    || /^documents\/acquisition\/[0-9a-f-]{36}$/i.test(currentSection)
    || knownHomeSections.has(currentSection);
}

function isLegacyDocumentSection(section: string): boolean {
  return section === 'documenti'
    || section === 'documents/console'
    || section === 'documents/console/taxonomies'
    || section === 'documents/console/document-types'
    || section === 'documents/console/intake'
    || section === 'documents/console/documents'
    || section === 'documents/console/documents/new'
    || /^documents\/console\/intake\/[0-9a-f-]{36}$/i.test(section)
    || /^documents\/console\/documents\/[0-9a-f-]{36}$/i.test(section);
}
